import React from 'react'
import { Box, Paper } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useQuery, useMutation, queryCache } from 'react-query'
import { useSnackbar } from 'notistack'
import { createArticle, getSections } from 'services/knowledgeBase'
import KnowledgeBaseForm from 'components/KnowledgeBaseForm'
import { IArticleForm } from 'typescript/interfaces/knowledgeBase'
import { KB_LIST_URL } from 'constants/routes'
import { SOMETHING_WENT_WRONG } from 'constants/errors'

const KnowledgeBaseCreate = () => {
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const { data: sections } = useQuery('kb-sections', getSections)

  const [createArticleMut, { isLoading }] = useMutation(createArticle, {
    onSuccess: () => {
      queryCache.invalidateQueries('kb-articles')
      enqueueSnackbar('Page successfully published')
      history.push(KB_LIST_URL)
    },
    onError: () => enqueueSnackbar(SOMETHING_WENT_WRONG),
  })

  const initValues: IArticleForm = {
    title: '',
    sectionId: '',
    bodyHtml: '',
    isPinned: false,
  }

  return (
    <Box component={Paper} p="3rem" mb="2rem">
      <KnowledgeBaseForm
        heading="Add Page"
        sections={sections ? sections.data : []}
        initValues={initValues}
        loading={isLoading}
        onSubmit={createArticleMut}
        onCancel={() => history.push(KB_LIST_URL)}
      />
    </Box>
  )
}

export default KnowledgeBaseCreate
